import isEqual from 'lodash/isEqual';
import { useEffect, useRef } from 'react';
import { useStore } from 'react-redux';

const useProjectWizardPendingChangesRef = ({
  enabled,
  selectFormValues,
  draftBaselineFormValues,
  draftBaselinePdfReports,
  pdfReports,
}) => {
  const hasPendingChangesRef = useRef(false);
  const store = useStore();

  useEffect(() => {
    if (!enabled) {
      hasPendingChangesRef.current = false;
      return undefined;
    }

    const updatePendingChanges = () => {
      if (draftBaselineFormValues == null) {
        hasPendingChangesRef.current = false;
        return;
      }

      const formValues = selectFormValues()(store.getState());
      hasPendingChangesRef.current =
        !isEqual(formValues, draftBaselineFormValues) ||
        !isEqual(pdfReports, draftBaselinePdfReports);
    };

    updatePendingChanges();
    return store.subscribe(updatePendingChanges);
  }, [
    enabled,
    store,
    selectFormValues,
    draftBaselineFormValues,
    draftBaselinePdfReports,
    pdfReports,
  ]);

  return hasPendingChangesRef;
};

export default useProjectWizardPendingChangesRef;
